import { useState } from "react";
import { ADS_PAGE_LEAD, ADS_TAB_COPY } from "../../util/adsCopy";
import {
    ADS_TOUR,
    adsTourProgress,
    adsTourSteps,
    isLastAdsTourStep,
    nextAdsTourIndex,
    prevAdsTourIndex,
    readAdsTourDismissed,
    writeAdsTourDismissed,
} from "../../util/adsTour";

const AdsGuide = ({ tab, visibleTabs = [], onSelect }) => {
    const copy = ADS_TAB_COPY[tab] || ADS_TAB_COPY.Sponsors;
    const names = visibleTabs.map((item) => item.name);
    const path = adsTourSteps(names);
    const [tourActive, setTourActive] = useState(false);
    const [dismissed, setDismissed] = useState(readAdsTourDismissed);
    const stepIndex = Math.max(0, path.findIndex((item) => item.tab === tab));
    const step = path[stepIndex] || path[0];
    const tourCopy = step ? ADS_TAB_COPY[step.tab] : copy;

    const closeTour = () => setTourActive(false);

    const startTour = () => {
        setTourActive(true);
        if (path[0]) {
            onSelect(path[0].tab);
        }
    };

    const goTo = (index) => {
        const next = path[index];
        if (next) {
            onSelect(next.tab);
        }
    };

    const dismissTour = () => {
        writeAdsTourDismissed();
        setDismissed(true);
        closeTour();
    };

    return (
        <section className="ads-guide" data-testid="ads-guide">
            <div className="ads-guide-top">
                <p className="ads-lead">{ADS_PAGE_LEAD}</p>
                {!dismissed && path.length > 0 && !tourActive && (
                    <button type="button" className="ads-btn ads-btn-secondary ads-tour-start" onClick={startTour}>
                        {ADS_TOUR.start}
                    </button>
                )}
            </div>
            {tourActive && path.length > 0 && (
                <div className="ads-path">
                    {path.map((item) => (
                        <button
                            key={item.tab}
                            type="button"
                            className={`ads-path-step${tourActive && step?.tab === item.tab ? " ads-path-step--tour" : ""}`}
                            aria-current={tab === item.tab ? "step" : undefined}
                            onClick={() => onSelect(item.tab)}
                        >
                            <span className="ads-path-num">{item.step}</span>
                            <span>
                                <strong>{item.label}</strong>
                                <em>{item.tab}</em>
                            </span>
                        </button>
                    ))}
                </div>
            )}
            {tourActive && step && (
                <div className="ads-tour" data-testid="ads-tour" role="dialog" aria-labelledby="ads-tour-title">
                    <p className="ads-tour-progress">{adsTourProgress(stepIndex, path.length)}</p>
                    <h2 id="ads-tour-title">{step.label}</h2>
                    <p className="ads-tab-guide-meaning">{tourCopy.meaning}</p>
                    <p>{tourCopy.how}</p>
                    <div className="ads-tour-actions">
                        <button
                            type="button"
                            className="ads-btn ads-btn-secondary"
                            disabled={stepIndex === 0}
                            onClick={() => goTo(prevAdsTourIndex(stepIndex))}
                        >
                            {ADS_TOUR.back}
                        </button>
                        {isLastAdsTourStep(stepIndex, path.length) ? (
                            <button type="button" className="ads-btn ads-btn-primary" onClick={closeTour}>
                                {ADS_TOUR.done}
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="ads-btn ads-btn-primary"
                                onClick={() => goTo(nextAdsTourIndex(stepIndex, path.length))}
                            >
                                {ADS_TOUR.next}
                            </button>
                        )}
                        <button type="button" className="ads-btn ads-btn-secondary" onClick={closeTour}>
                            {ADS_TOUR.skip}
                        </button>
                        <button type="button" className="ads-tour-dismiss" onClick={dismissTour}>
                            {ADS_TOUR.dismiss}
                        </button>
                    </div>
                </div>
            )}
            {!tourActive && (
                <p className="ads-tab-guide-meaning ads-tab-guide-idle">{copy.meaning}</p>
            )}
        </section>
    );
};

export default AdsGuide;
